module.exports = __webpack_public_path__ + "img/g_yin.81b009fd.png";